import { Modal } from 'antd'
import { MessageInstance } from 'antd/es/message/interface'
import { FormFieldsByUniqueID } from 'components/form/formTypes'
import { Expandable } from 'components/table/utility/expandableTable'
import React, { RefObject, useEffect, useState } from 'react'
import styled from 'styled-components'
import { GeckoSite, GeckoSiteGrouping, RolodexEntryPatchJson } from 'types'

import { GroupingsTableCard } from './GroupingsTableCard'

const SelectButton = styled.button<{ disabled: boolean }>`
  padding: 0.375rem 1rem;
  background-color: ${(props) => (props.disabled ? '#d9d9d9' : '#1890ff')};
  color: ${(props) => (props.disabled ? 'rgba(0, 0, 0, 0.25)' : 'white')};
  border: none;
  border-radius: 0.375rem;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`
interface GroupingsSelectionModalProps {
  site: GeckoSite | undefined
  existingGroupings: GeckoSiteGrouping[]
  handleOpenGroupingInfoModal: () => void
  handleEditGroupingInfo: (row: Expandable<GeckoSiteGrouping>) => void
  isGroupingInfoModalOpen: boolean
  groupingFormRef: RefObject<HTMLFormElement>
  handleCloseGroupingInfoModal: () => void
  handleSaveGroupingInfo: () => void
  handlePatchToRolodex: (
    entry: RolodexEntryPatchJson<
      Partial<GeckoSite['data']>,
      Partial<GeckoSite['tags']>
    >,
    messageApi?: MessageInstance
  ) => void
  handleCancelGroupingInfo: () => void
  groupingID: string | undefined
  groupingInfoFormFields: FormFieldsByUniqueID[]
  // Selection modal specific props
  isOpen: boolean
  onCancel: () => void
  selectedGroupingId: string | undefined
  onSelectGrouping: (groupingId: string) => void
}

export const GroupingsSelectionModal: React.FC<
  GroupingsSelectionModalProps
> = ({
  site,
  existingGroupings,
  handleOpenGroupingInfoModal,
  handleEditGroupingInfo,
  isGroupingInfoModalOpen,
  groupingFormRef,
  handleCloseGroupingInfoModal,
  handleSaveGroupingInfo,
  handlePatchToRolodex,
  handleCancelGroupingInfo,
  groupingID,
  groupingInfoFormFields,
  isOpen,
  onCancel,
  selectedGroupingId,
  onSelectGrouping,
}) => {
  const [internalSelectedGroupingId, setInternalSelectedGroupingId] = useState<
    string | undefined
  >(selectedGroupingId)
  useEffect(() => {
    if (isOpen) {
      setInternalSelectedGroupingId(selectedGroupingId)
    }
  }, [isOpen, selectedGroupingId])

  const handleConfirmSelection = () => {
    if (internalSelectedGroupingId) {
      onSelectGrouping(internalSelectedGroupingId)
    }
  }

  const handleInternalSelection = (groupingId: string) => {
    setInternalSelectedGroupingId(groupingId)
  }

  return (
    <Modal
      title='Select Grouping'
      open={isOpen}
      onCancel={onCancel}
      width='56.25rem'
      footer={[
        <SelectButton
          key='select'
          onClick={handleConfirmSelection}
          disabled={!internalSelectedGroupingId}>
          Select Grouping
        </SelectButton>,
      ]}>
      <GroupingsTableCard
        site={site}
        existingGroupings={existingGroupings}
        groupingID={groupingID}
        groupingInfoFormFields={groupingInfoFormFields}
        handleOpenGroupingInfoModal={handleOpenGroupingInfoModal}
        handleEditGroupingInfo={handleEditGroupingInfo}
        isGroupingInfoModalOpen={isGroupingInfoModalOpen}
        groupingFormRef={groupingFormRef}
        handleCloseGroupingInfoModal={handleCloseGroupingInfoModal}
        handleSaveGroupingInfo={handleSaveGroupingInfo}
        handlePatchToRolodex={handlePatchToRolodex}
        handleCancelGroupingInfo={handleCancelGroupingInfo}
        selectionMode={true}
        selectedGroupingId={internalSelectedGroupingId}
        onSelectGrouping={handleInternalSelection}
      />
    </Modal>
  )
}
